import { Outlet } from 'react-router-dom'
import Navbar from './Navbar'
import Footer from './Footer'
import ScrollToTop from './ScrollToTop'
import PageTransition from './PageTransition'
import WhatsAppFab from './WhatsAppFab'
import ScrollProgress from './ScrollProgress'
import { useCatalogueStream } from '../../hooks/useCatalogueStream'

/* The shell every route renders inside. */
function Layout() {
  /* Opened once, here, so the floor stays current on whichever page the
     visitor is reading — a car sold behind the desk stops being advertised
     within the second rather than at the end of the browser's cache. */
  useCatalogueStream()

  return (
    <>
      <ScrollToTop />
      <ScrollProgress />
      <Navbar />
      <main>
        <PageTransition>
          <Outlet />
        </PageTransition>
      </main>
      <Footer />
      <WhatsAppFab />
    </>
  )
}

export default Layout
